import { render, staticRenderFns } from "./ViewPolicy.vue?vue&type=template&id=38380768&"
import script from "./ViewPolicy.vue?vue&type=script&lang=js&"
export * from "./ViewPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ViewPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports